// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.box.box-solid.box-primary > .box-header {
  background: #3488a9;
}

.box.box-solid.box-primary {
  border: 1px solid #3488a9;
}

.box.box-primary {
  border-top-color: #6c7e9d;
}

.box.box-solid.box-warning > .box-header {
  background: #dba11c;
}

.box.box-solid.box-warning {
  border: 1px solid #dba11c;
}

.box.box-warning {
  border-top-color: #dba11c;
}

.box.box-solid.box-success > .box-header {
  background: #008a60;
}

.box.box-solid.box-success {
  border: 1px solid #008a60;
}

.box.box-success {
  border-top-color: #008a60;
}

.box-footer {
  border-top-color: #eee;
}

.sidebar-mini.sidebar-collapse .sidebar-menu > li:hover > a > span:not(.pull-right), .sidebar-mini.sidebar-collapse .sidebar-menu > li:hover > .treeview-menu {
  width: 230px;
}

.sidebar-mini.sidebar-collapse .search {
  display: none;
  transform: translateZ(0);
}

.skin-purple.sidebar-collapse .sidebar-menu > li > .treeview-menu {
  background: none;
  height: 1000px;
  padding-top: 0;
  padding-left: 0;
}

.sidebar-menu .treeview-menu > li {
  background: #2c3b41;
}

.sidebar-menu .treeview.active > a > span {
  font-weight: 600;
}
`, "",{"version":3,"sources":["webpack://./home/autoboss/ipfabric-product/services/frontend/app/containers/App/styles/redesignDefaultStyles.css","webpack://./services/frontend/app/containers/App/styles/redesignDefaultStyles.css"],"names":[],"mappings":"AADA;ECEE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".box.box-solid.box-primary > .box-header {\n  background: #3488a9;\n  background-color: #3488a9;\n}\n\n.box.box-solid.box-primary {\n  border: 1px solid #3488a9;\n}\n\n.box.box-primary {\n  border-top-color: #6c7e9d;\n}\n\n.box.box-solid.box-warning > .box-header {\n  background: #dba11c;\n  background-color: #dba11c;\n}\n\n.box.box-solid.box-warning {\n  border: 1px solid #dba11c;\n}\n\n.box.box-warning {\n  border-top-color: #dba11c;\n}\n\n.box.box-solid.box-success > .box-header {\n  background: #008a60;\n  background-color: #008a60;\n}\n\n.box.box-solid.box-success {\n  border: 1px solid #008a60;\n}\n\n.box.box-success {\n  border-top-color: #008a60;\n}\n\n.box-footer {\n  border-top-color: #eee;\n}\n\n.sidebar-mini.sidebar-collapse\n  .sidebar-menu\n  > li:hover\n  > a\n  > span:not(.pull-right),\n.sidebar-mini.sidebar-collapse .sidebar-menu > li:hover > .treeview-menu {\n  width: 230px;\n}\n\n.sidebar-mini.sidebar-collapse .search {\n  display: none;\n  transform: translateZ(0);\n}\n\n.skin-purple.sidebar-collapse .sidebar-menu > li > .treeview-menu {\n  /* hack to prevent disappearing of menu after click to last item */\n  background: transparent;\n  height: 1000px;\n  padding-top: 0;\n  padding-left: 0;\n}\n\n.sidebar-menu .treeview-menu > li {\n  background: #2c3b41;\n}\n\n/* Highlight expanded menu item */\n\n.sidebar-menu .treeview.active > a > span {\n  font-weight: 600;\n}\n",".box.box-solid.box-primary > .box-header {\n  background: #3488a9;\n}\n\n.box.box-solid.box-primary {\n  border: 1px solid #3488a9;\n}\n\n.box.box-primary {\n  border-top-color: #6c7e9d;\n}\n\n.box.box-solid.box-warning > .box-header {\n  background: #dba11c;\n}\n\n.box.box-solid.box-warning {\n  border: 1px solid #dba11c;\n}\n\n.box.box-warning {\n  border-top-color: #dba11c;\n}\n\n.box.box-solid.box-success > .box-header {\n  background: #008a60;\n}\n\n.box.box-solid.box-success {\n  border: 1px solid #008a60;\n}\n\n.box.box-success {\n  border-top-color: #008a60;\n}\n\n.box-footer {\n  border-top-color: #eee;\n}\n\n.sidebar-mini.sidebar-collapse .sidebar-menu > li:hover > a > span:not(.pull-right), .sidebar-mini.sidebar-collapse .sidebar-menu > li:hover > .treeview-menu {\n  width: 230px;\n}\n\n.sidebar-mini.sidebar-collapse .search {\n  display: none;\n  transform: translateZ(0);\n}\n\n.skin-purple.sidebar-collapse .sidebar-menu > li > .treeview-menu {\n  background: none;\n  height: 1000px;\n  padding-top: 0;\n  padding-left: 0;\n}\n\n.sidebar-menu .treeview-menu > li {\n  background: #2c3b41;\n}\n\n.sidebar-menu .treeview.active > a > span {\n  font-weight: 600;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
